/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

$(document).ready(function () {
  var email = $('#mitarbeiter').find(':selected').data('email');
  fillEmail(email);
});

$('#mitarbeiter').on('change', function () {
  var email = $(this).find(':selected').data('email');
  fillEmail(email);
});

function fillEmail(email) {
  if (email != undefined && email != 'undefined' && email != '') {
    $('#email').val(email);
    $('#email').attr('readonly', true);
  } else {
    $('#email').val('');
    $('#email').attr('readonly', false);
  }
}
